var map = {
	"./aerobics-girl.png": 1190,
	"./alien.png": 1191,
	"./arcade-cabinet.png": 1192,
	"./aviator-glasses.png": 1193,
	"./boombox.png": 1194,
	"./cassette.png": 1195,
	"./delorean.png": 1196,
	"./electroguitar.png": 1197,
	"./elvis.png": 1198,
	"./floppy.png": 1199,
	"./ghost.png": 1200,
	"./hustler.png": 1201,
	"./joystick.png": 1202,
	"./officer.png": 1203,
	"./pc.png": 1204,
	"./pizza.png": 1205,
	"./player.png": 1206,
	"./rollers.png": 1207,
	"./skateboard.png": 1208,
	"./sneakers.png": 1209,
	"./synthesizer.png": 1210,
	"./telephone.png": 1211,
	"./tv.png": 1212,
	"./yuppie.png": 1213,
	"./zombie.png": 1214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1189;